import { RiskLevel, RiskScale } from "../../models/RiskScale";

interface BadgeProps {
  level: RiskLevel | string;
}

export function Badge({ level }: BadgeProps) {
  // Convert string to RiskLevel enum if needed, with validation
  let riskLevel: RiskLevel;
  if (typeof level === "string") {
    const upperLevel = level.toUpperCase();
    // Validate that the string is a valid RiskLevel
    if (Object.values(RiskLevel).includes(upperLevel as RiskLevel)) {
      riskLevel = upperLevel as RiskLevel;
    } else {
      // Invalid risk level string, default to UNKNOWN
      riskLevel = RiskLevel.UNKNOWN;
    }
  } else {
    riskLevel = level;
  }

  const { color, textColor } = RiskScale.getColorClasses(riskLevel);

  return (
    <span
      className={`px-3 py-1 rounded font-semibold text-sm uppercase ${color} ${textColor}`}
    >
      {riskLevel}
    </span>
  );
}
